import styles from '@ui/components/Card/components/CardBody/CardBody.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CardBody = ({ children, className = null }) => (
  <div className={classNames(styles.container, className)}>{children}</div>
);

CardBody.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default CardBody;
